exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.menu-container[data-v-49aff120] {\n  background: rgba(255, 255, 255, 0.98);\n}\n", ""]);

// exports
